// Shared frontend helper — maps Feb 2026 backend scan/source enums to
// customer-facing labels and Tailwind class hints. MUST stay in sync with
// backend/models.py::source_status_label() / scan_status_label().

export const SCAN_STATUS_LABEL = {
  queued: 'Queued',
  running: 'Running',
  completed: 'Completed',
  complete: 'Completed',
  completed_with_source_issues: 'Completed with Source Issues',
  awaiting_user_action: 'Awaiting User Action',
  partially_completed: 'Partially Completed',
  partial: 'Partially Completed',
  cancelled: 'Cancelled',
  failed: 'Failed',
};

export const SOURCE_STATUS_LABEL = {
  pending: 'Pending',
  running: 'Scanning',
  paused_verification_required: 'Verification Required',
  awaiting_user: 'User Action Required',
  rate_limited: 'Rate Limited',
  temporarily_unavailable: 'Temporarily Unavailable',
  source_error: 'Source Issue',
  retry_available: 'Retry Available',
  stopped_for_safety: 'Stopped for Safety',
  completed: 'Completed',
  complete: 'Completed',
  skipped: 'Skipped',
  failed: 'Source Issue',
  requires_extension: 'Guided Scan setup required',
};

// Utility badge classes that match the existing `op-*` / `ari-chip` styles.
export const SOURCE_STATUS_CLASS = {
  pending: 'op-mod',
  running: 'op-worth',
  paused_verification_required: 'ari-chip',
  awaiting_user: 'ari-chip',
  rate_limited: 'op-mod',
  temporarily_unavailable: 'op-mod',
  source_error: 'op-low',
  retry_available: 'op-mod',
  stopped_for_safety: 'op-low',
  completed: 'op-strong',
  complete: 'op-strong',
  skipped: 'op-mod',
  failed: 'op-low',
  requires_extension: 'op-mod',
};

export function sourceStatusLabel(state) {
  return SOURCE_STATUS_LABEL[state] || (state || '').replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function scanStatusLabel(state) {
  return SCAN_STATUS_LABEL[state] || (state || '').replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function sourceStatusClass(state) {
  return SOURCE_STATUS_CLASS[state] || 'op-mod';
}

// A Guided Scan source is one of the 4 authenticated platforms. Used by the
// UI to gate Resume/Rerun step-up prompts.
export const GUIDED_SOURCE_KEYS = new Set([
  'facebook_marketplace',
  'facebook_groups',
  'offerup',
  'nextdoor',
]);

export function isGuidedSource(sourceKey) {
  return GUIDED_SOURCE_KEYS.has(sourceKey);
}

// State machine helpers
export function isResumable(state) {
  return [
    'paused_verification_required',
    'awaiting_user',
    'rate_limited',
    'temporarily_unavailable',
    'retry_available',
  ].includes(state);
}

export function isTerminal(state) {
  return [
    'completed', 'complete', 'skipped', 'source_error', 'failed',
    'stopped_for_safety',
  ].includes(state);
}

export function isRerunnable(state) {
  return !['running', 'pending', 'paused_verification_required', 'awaiting_user'].includes(state);
}
